import type { ReactNode } from "react";
import { Container, Grid, Typography } from "@mui/material";
import InformationBox from "components/InformationBox";
import PageTitle from "components/PageTitle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PersonneForm from "./components/PersonneForm";
import { Authorization } from "@sdeapps/react-core";
import { ApplicationRole } from "constants/ApplicationRole";
import { withPageErrorBoundary } from "utils/errorHandling";

function NewPersonne(): ReactNode {
  return (
    <Container>
      <Authorization
        roles={[ApplicationRole.ADMINISTRATOR, ApplicationRole.GESTIONNAIRE_ELECTIONS]}>
        <Grid container spacing={2}>
          <PageTitle title="Nouvelle Personne" />
          <Grid container size={12}>
            <InformationBox icon={VisibilityIcon} articleTitle="Informations générales">
              <Typography variant="caption">
                Merci de vérifier que la personne n'existe pas déjà avant de la créer.
              </Typography>
              <PersonneForm />
            </InformationBox>
          </Grid>
        </Grid>
      </Authorization>
    </Container>
  );
}

const NewPersonneWithErrorBoundary = withPageErrorBoundary(NewPersonne);
export default NewPersonneWithErrorBoundary;
